import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/images/voucher.png';
import _imports_1 from '@/assets/images/icons/icon_check.svg';
import _imports_2 from '@/assets/images/icons/icon_checked.svg';
import _imports_3 from '@/assets/images/coupon_split_line.svg';
var _hoisted_1 = {
  class: "main-info-content"
};
var _hoisted_2 = {
  class: "coupon-name"
};
var _hoisted_3 = {
  class: "discount"
};
var _hoisted_4 = {
  class: "icon-checkbox-wrap"
};
var _hoisted_5 = {
  class: "icon-checkbox",
  src: _imports_1,
  alt: ""
};
var _hoisted_6 = {
  class: "icon-checkbox",
  src: _imports_2,
  alt: ""
};
var _hoisted_7 = {
  class: "extend-info"
};
var _hoisted_8 = {
  class: "extend-info-main"
};
var _hoisted_9 = {
  class: "min-spend"
};
import { priceUtil } from "@op/shared";
export default {
  __name: 'VoucherCodeItem',
  props: {
    voucherCodeItem: {
      type: Object,
      default: function _default() {}
    },
    selectedCardNumber: {
      type: String,
      default: ""
    }
  },
  emits: ["select"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    function handleSelect() {
      emits("select");
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["select-coupon", {
          'select-coupon--disabled': __props.voucherCodeItem.balance === 0
        }])
      }, [_createElementVNode("div", {
        class: "main-info",
        onClick: handleSelect
      }, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "coupon-img-wrap"
      }, [_createElementVNode("img", {
        class: "coupon-img",
        src: _imports_0,
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.voucherCodeItem.card_number), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("availableBalance", [_unref(priceUtil).formatBaseUnitToShowPrice(__props.voucherCodeItem.balance)])), 1)]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_vShow, __props.selectedCardNumber !== __props.voucherCodeItem.card_number]]), _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_vShow, __props.selectedCardNumber === __props.voucherCodeItem.card_number]])]), _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_3,
        class: "coupon-split-line"
      }, null, -1))]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("reEnterCodeTips")), 1)])])], 2);
    };
  }
};